var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVoir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.692,
    height: 20,
    viewBox: "0 0 25.692 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6809",
    "data-name": "Groupe 6809",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 3.244,
    cy: 3.244,
    r: 3.244,
    transform: "translate(9.602 6.756)",
    fill: "#cbc9c9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7277",
    "data-name": "Groupe 7277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9637",
    "data-name": "Trac\\xE9 9637",
    d: "M24.907,63.952c-1.66-2.7-5.435-7.238-12.061-7.238S2.445,61.249.785,63.952a5.252,5.252,0,0,0,0,5.524c1.66,2.7,5.435,7.238,12.061,7.238s10.4-4.535,12.061-7.238A5.252,5.252,0,0,0,24.907,63.952ZM12.846,73.135a6.421,6.421,0,1,1,6.421-6.421A6.421,6.421,0,0,1,12.846,73.135Z",
    transform: "translate(0 -56.714)",
    fill: "#cbc9c9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoir);
export default __webpack_public_path__ + "static/media/iconVoir.9cf69d2d2a90eee39692e34fbf678843.svg";
export { ForwardRef as ReactComponent };